import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/index'
import * as utils from '@/utils/utils'
import { initWebSocket } from '@/utils/websocket'
let wx = require('weixin-js-sdk')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: '', // websocket登陆成功
    messages: [], // 消息
    loginInfo: null, // 登录信息
    ws: null, // websocket
    wx: null, // 微信语音配追
    chatClose: false, // 结束会话
    inviteEvaluation: null, // 评价邀请
    blackClose: false, // 黑名单
    leaveMsg: false, // 去留言
    lineup: null, // 排队
    autoTurnManual: '', // 自动转人工
    switching: '', // 转接客服
    isWechat: '', // 判断是否在微信中
    isiOS: '', // 判断是否是 ios
    isMobile: '', // 判断是否是 ios
    initialData: {}, // 初始化数据
    sayMsg: '', // 收到或发送消息标记
    isAiReply: false // 是否是ai回复
  },
  mutations: {
    LOGIN (state, data) {
      state.login = data
    },
    SET_LOGIN_INFO (state, data) {
      state.loginInfo = data
    },
    SET_AUTOGRAPH (state, data) {
      state.agent_sign = data
    },
    SET_WS (state, data) {
      state.ws = data
    },
    RESET_MSG (state, data) {
      state.messages = []
    },
    UPDATE_MSG (state, data) {
      state.messages.push(data)
    },
    LOAD_HIS_MSG (state, data) {
      state.messages.unshift(data)
    },
    CHAT_CLOSE (state, data) {
      state.chatClose = data
    },
    INVITE_EVALUATION (state, data) {
      state.inviteEvaluation = data
    },
    BLACK_CLOSE (state, data) {
      state.blackClose = data
    },
    LEAVE_MSG (state, data) {
      state.leaveMsg = data
    },
    LINE_UP (state, data) {
      state.lineup = data
    },
    REVOKE_MSG (state, data) {
      state.messages = data
    },
    SAY_MSG (state, data) {
      state.sayMsg = data
    },
    SWITCHING (state, data) {
      state.switching = data
    },
    AUTO_TURN_MANUAL (state, data) {
      state.autoTurnManual = data
    },
    IS_IOS (state, data) {
      state.isiOS = data
    },
    IS_WECHAT (state, data) {
      state.isWechat = data
    },
    IS_MOBILE (state, data) {
      state.isMobile = data
    },
    INITIAL_DATA (state, data) {
      state.initialData = data
    },
    SET_WX (state, data) {
      state.wx = data
    },
    IS_AI_REPLY (state, data) {
      state.isAiReply = data
    },
  },
  actions: {
    // 判断设备
    _deviceJudge ({ commit }) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
        commit('IS_IOS', true)
      } else {
        commit('IS_IOS', false)
      }
      if (/(MicroMessenger)/i.test(navigator.userAgent)) { // 微信浏览器
        commit('IS_WECHAT', true)
      } else {
        commit('IS_WECHAT', false)
      }
      if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        commit('IS_MOBILE', true)
      } else {
        commit('IS_MOBILE', false)
      }
    },
    _getInitial ({ state, commit }, cid) {
      return new Promise((resolve, reject) => {
        api.getInitialDataAPI({
          cid: cid
        }).then(res => {
          if (res.status === '1') {
            commit('INITIAL_DATA', res.data)
          }
        })
      })
    },
    // 登录
    _login ({ state, commit }, params, data) {
      return new Promise((resolve, reject) => {
        api.loginAPI(params).then(res => {
          // 评价页面不创建ws
          let curr_hash = window.location.hash
          if(curr_hash.indexOf('/evaluate') > -1) {
            return false
          }
          if (res.status === '1') {
            commit('RESET_MSG')
            let loginChats = res.data
            commit('SET_LOGIN_INFO', loginChats)
            commit('SET_AUTOGRAPH', loginChats.agent_sign)
            // console.log(loginChats.agent_sign)
            let messageArr = []
            for (let uid in loginChats.chats) {
              messageArr = loginChats.chats[uid].messages
            }
            if (messageArr.length > 0) {
              messageArr.map(item => {
                commit('UPDATE_MSG', item)
              })
            }
            // 订单 数据
            if (loginChats.order_info && Object.keys(loginChats.order_info).length > 0) {
              let orderInfoMsg = {
                'type': 'say',
                'sendtime': '' + utils.getTimes(),
                'role': 'agent',
                'agent_avatar': loginChats.agent_avatar,
                'agent_nickname': loginChats.agent_nickname,
                'msg_type': 'orderInfo',
                'agent_type': loginChats.agent_type,
                'flag': loginChats.order_info.flag,
                'text': JSON.stringify(loginChats.order_info)
              }
              commit('UPDATE_MSG', orderInfoMsg)
            }

            // 当前浏览的商品数据
            if (loginChats.goodsinfo && Object.keys(loginChats.goodsinfo).length > 0) {
              let goodsData = {
                'role': 'sendGoods',
                'msg_type': 'sendGoods',
                'isShow': 'show',
                'text': JSON.stringify(loginChats.goodsinfo)
              }
              commit('UPDATE_MSG', goodsData)
            }

            if (!state.ws || state.lineup) {
              commit('SET_WS', null)
              setTimeout(function () {
                loginChats.consult = params.consult
                loginChats.consultLink = params.consultLink
                let wss = initWebSocket(loginChats)
                commit('SET_WS', wss)
              },0)
            }
            if (params.choose) {
              let switchData = {
                type: 'switching',
                role: 'agent',
                from_uid: data, // 机器人客服id
                to_uid: res.data.client_uid, // 访客id
                switch_agent_uid: res.data.agent_uid, // 人工客服id
                switch_name: res.data.agent_nickname,
                switch_avater: res.data.agent_avatar,
                messages_history: '',
                messages_id: ''
              }
              state.ws.send(JSON.stringify({
                switching: {
                  message: switchData
                }
              }))
            }
            // 微信语音配置
            if (/(MicroMessenger)/i.test(navigator.userAgent)) { // 微信浏览器
              api.getWechatConfigAPI({
                url: encodeURIComponent(window.location.href.split('#')[0]), // document.referrer
                visitorId: loginChats.client_uid
              }).then(result => {
                if (result.appId) {
                  wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: result.appId, // 必填，公众号的唯一标识
                    timestamp: result.timestamp, // 必填，生成签名的时间戳
                    nonceStr: result.nonceStr, // 必填，生成签名的随机串
                    signature: result.signature, // 必填，签名
                    jsApiList: ['startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'stopVoice', 'uploadVoice', 'downloadVoice'] // 必填，需要使用的JS接口列表
                  })
                  commit('SET_WX', wx)
                } else {

                }
              })
            }
          } else if (res.status === '2') {
            let loginChats = res.data
            commit('SET_LOGIN_INFO', loginChats)
            commit('SET_AUTOGRAPH', loginChats.agent_sign)
            if (!state.ws) {
              let initWsParam = res.data
              initWsParam.agent_uid = 0
              initWsParam.consult = params.consult
              initWsParam.consultLink = params.consultLink
              let wss = initWebSocket(initWsParam)
              commit('SET_WS', wss)
            }
            commit('LINE_UP', {
              lineup: true,
              obj: res.data
            })
          }else {
            let loginChats = res.data
            commit('SET_LOGIN_INFO', loginChats)
            commit('SET_AUTOGRAPH', loginChats.agent_sign)
            commit('LEAVE_MSG', true)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // websocket连成功
    _loginSuccess ({ commit }, msg) {
      commit('LOGIN', msg)
    },
    // 更新消息
    _updateMsg ({ commit }, msg) {
      commit('UPDATE_MSG', msg)
    },
    // 清空消息
    _clearMsg ({ commit }, msg) {
      commit('RESET_MSG')
    },
    // 渲染历史消息消息
    _loadHistoryMsg ({ commit }, msg) {
      commit('LOAD_HIS_MSG', msg)
    },
    // 结束会话
    _chatClose ({ commit }, msg) {
      commit('CHAT_CLOSE', msg)
    },
    // 结束会话
    _inviteEvaluation ({ commit }, msg) {
      commit('INVITE_EVALUATION', msg)
    },
    // 黑名单
    _blackClose ({ commit }, msg) {
      commit('BLACK_CLOSE', msg)
    },
    // 收到或者发送消息
    _sayMsg ({ commit }, msg) {
      commit('SAY_MSG', msg)
    },
    // 结束会话
    _revokeMsg ({ state, commit }, msg) {
      let stateMsg = state.messages
      stateMsg.map((item, i) => {
        if (item.callingId === msg.callingId) {
          stateMsg.splice(i, 1, msg)
        }
      })
      commit('REVOKE_MSG', stateMsg)
    },
    // 自动转人工
    _autoTurnManual ({ state, commit }, msg) {
      commit('AUTO_TURN_MANUAL', msg)
    },
    // 转接客服
    _switchingMsg ({ state, commit }, msg) {
      commit('SWITCHING', msg)
    },
    // 修改排队状态
    _updateQueuueNum ({ state, commit }, msg) {
        let newData = state.lineup
      newData.obj.queue_up_num = msg
      commit('LINE_UP',newData)
    },
    // 是否是ai回复
    _isAiReply ({ commit }, msg) {
      commit('IS_AI_REPLY', msg)
    },
  }
})
